export default function BenefitsSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/aa7e07b57457a4e6c9b363c503d99b31.jpg"
              alt="Benefits of Selling Apartments for Cash"
              className="rounded-2xl shadow-2xl w-full h-full object-cover object-top"
            />
            <div className="absolute -bottom-8 -right-8 bg-white rounded-2xl p-8 shadow-2xl max-w-xs">
              <div className="flex items-center space-x-4">
                <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-star-fill text-white text-3xl"></i>
                </div>
                <div>
                  <div className="text-3xl font-bold text-gray-900">4.9/5</div>
                  <div className="text-gray-600">Average Seller Rating</div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              Benefits
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Benefits of Selling Your Apartments to Us
            </h2>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              When you choose to sell my apartments to T-Rex Real Estate, you gain numerous advantages over traditional sales methods. Our proven track record and title company process ensure a smooth, secure transaction.
            </p>

            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-fill text-teal-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Save 6-12 Months of Time</h3>
                  <p className="text-gray-600 leading-relaxed">Traditional apartment sales take 6-12 months on average. We close in 7-14 days, allowing you to move on with your plans immediately.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-money-dollar-circle-fill text-teal-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">No Commissions or Fees</h3>
                  <p className="text-gray-600 leading-relaxed">Save 6% in real estate commissions plus closing costs. Our offer is what you receive—no hidden fees or surprise deductions.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-tools-fill text-teal-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Zero Repairs or Renovations</h3>
                  <p className="text-gray-600 leading-relaxed">We buy apartments as-is. No need to fix roofs, update units, repair plumbing, or make any improvements. Save tens of thousands in repair costs.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-fill text-teal-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Title Company Security</h3>
                  <p className="text-gray-600 leading-relaxed">Every transaction is handled through a reputable title company, ensuring proper documentation, title insurance, and secure fund transfers.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-group-fill text-teal-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Handle Tenant Situations</h3>
                  <p className="text-gray-600 leading-relaxed">We buy apartments with tenants in place. No need to evict, relocate, or deal with tenant issues. We take over all tenant relationships.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-file-list-3-fill text-teal-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">We Handle All Paperwork</h3>
                  <p className="text-gray-600 leading-relaxed">From purchase agreements to tenant notifications, we manage all documentation. The title company ensures everything is legally compliant.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}